/*
 * @Author: your name
 * @Date: 2020-07-25 15:41:24
 * @LastEditTime: 2020-07-25 16:17:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/api/workbench/index.js
 */
export default {
  module: 'WORKBENCH',
  QUERY_MY_TENANT_LIST: {
    url: '/xdap-admin/tenant/query/tenantListByUser',
    method: 'get',
    disableSuccessMsg: true
  },
  // 查询首页应用
  QUERY_HOME_LIST: {
    url: '/xdap-app/app/query/workspaceHome',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_TODO_COUNT: {
    url: '/xdap-app/app/query/queryTodoCount',
    method: 'get',
    disableSuccessMsg: true
  },
  GET_MESSAGE_COUNT: {
    url: '/xdap-admin/msg/count/newMessage',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_USER_TENANT_INFO: {
    url: '/xdap-admin/tenant/query/userTenantInfo',
    method: 'get',
    disableSuccessMsg: true
  }
}
